import { render, staticRenderFns } from "./LightLogin.vue?vue&type=template&id=57af0aca&scoped=true&"
import script from "./LightLogin.vue?vue&type=script&lang=js&"
export * from "./LightLogin.vue?vue&type=script&lang=js&"
import style0 from "./LightLogin.vue?vue&type=style&index=0&id=57af0aca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57af0aca",
  null
  
)

export default component.exports